<template>
<w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
  <component slot="activeView" :is="activeMenu"></component>
</w-settings-detail>
</template>

<script>
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WServer from './Server';
import WNetwork from './Network';
import WDatabase from './Database';
import WFacilityDevice from './FacilityDevice';
import WE2eDevice from './E2eDevice';
import WService from './Service';
import WVirtual from './Virtual'; // [가상화] 가상화 장비등록 하위메뉴 추가
import WApm from './Apm';

const defaultMenu = 'WServer';
const componentMap = {
  SMS: 'WServer',
  NMS: 'WNetwork',
  DBMS: 'WDatabase',
  FMS: 'WFacilityDevice',
  E2E: 'WE2eDevice',
  SVC: 'WService',
  VMS: 'WVirtual',
  APM2X: 'WApm',
};

export default {
  name: 'WDeviceRegistration',
  components: {
    WSettingsDetail,
    WServer,
    WNetwork,
    WDatabase,
    WFacilityDevice,
    WE2eDevice,
    WService,
    WVirtual,
    WApm,
  },
  props: {
    title: String,
  },
  computed: {
    activeManagetypesToShow() {
      return this.$store.getters.activeManagetypesToShow;
    },
    autoMoveMenuInfo() {
      return this.$store.getters.autoMoveMenuInfo;
    },
  },
  watch: {
    activeManagetypesToShow: {
      immediate: true,
      handler(to) {
        const menu = [];
        forEach(to, (item) => {
          menu.push({
            id: componentMap[item.managetypeId],
            name: item.managetypeName,
            active: false,
          });
        });
        this.menu = menu;
        const defaultMenuId = menu[0].id;
        this.defaultMenu = defaultMenuId;
        this.activeMenu = defaultMenuId;
      },
    },
    autoMoveMenuInfo: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val) && val.length >= 3) {
          const index = findIndex(this.menu, (item) => item.id === val[2].id);
          if (index >= 0) {
            this.defaultMenu = this.menu[index].id;
            this.activeMenu = this.menu[index].id;
            if (val.length === 3) {
              this.$store.dispatch('setAutoMoveMenuInfo', null);
            }
          }
        }
      },
    },
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
      menu: [],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/index.vue